export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';

export const UPDATE_DEVICE_REG_ID_REQUEST = 'UPDATE_DEVICE_REG_ID_REQUEST';
export const UPDATE_DEVICE_REG_ID_SUCCESS = 'UPDATE_DEVICE_REG_ID_SUCCESS';
export const UPDATE_DEVICE_REG_ID_ERROR = 'UPDATE_DEVICE_REG_ID_ERROR';
